import { Link } from "@fluentui/react"
import { AppLinkToExternal } from "global/Application"


interface IProps {
    id: string;
    name: string;
}

const SystemUser: React.FunctionComponent<IProps> = ({ id, name }) => {
    return <Link
        href={AppLinkToExternal({ type: 'systemuser', id: id })}
        target="_blank"
    >
        {name}
    </Link>
}

export default SystemUser;